import "@/styles/vendor.css";
import "@/styles/index.css";

import customScrollbar from "@/scripts/components/custom-scrollbar";
import form from "@/scripts/components/form/form";
import mediaSlider from "@/scripts/components/media-slider";
import modal from "@/scripts/components/modal";
import paginatedList from "@/scripts/components/paginated-list";
import scrollReveal from "@/scripts/components/scroll-reveal";
import scrollTo from "@/scripts/components/scroll-to";
import siteHeader from "@/scripts/components/site-header";
import siteMenu from "@/scripts/components/site-menu";
import slideToggle from "@/scripts/components/slide-toggle";

import Alpine from "alpinejs";
import focus from "@alpinejs/focus";
import { pillMarker } from "@/scripts/alpine/pill-marker";

window.Alpine = Alpine;

customScrollbar.init();
form.init();
mediaSlider.init();
modal.init();
paginatedList.init();
scrollReveal.init();
scrollTo.init();
siteHeader.init();
siteMenu.init();
slideToggle.init();

Alpine.plugin(focus);
Alpine.data("pillMarker", pillMarker);
Alpine.start();

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    document.documentElement.classList.remove("_preload");
  }, 250);
});
